import React, { useEffect, useState } from "react";
import * as cls from "./writtenWorks.module.scss";
import { useSelector } from "react-redux";
import { TableLoader, TableModel } from "../../components/tableLoader";
import MarkdownReportModal from "../../components/MarkdownReportModal/MarkdownReportModal";

function base64ToUtf8(base64) {
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder("utf-8").decode(bytes);
}
function WrittenWorks() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [reportContent, setReportContent] = useState(null);
  const loader = {
    title: "Письменные работы",
    icon: "survey",
    request: {
      method: "post",
      path: "/student/portfolio/written_works",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    const table = new TableModel(response);
    table.columns.forEach((element) => {
      if (element.field === "reports" || element.field === "theme") {
        element.type = "html";
      }
      if (element.field === "receiption_date") {
        element.type = "date";
      }
    });

    return table;
  }
  function handleClick(event) {
    const link = event.target.closest("a.markdown_report");
    if (!link) return;
    event.preventDefault();
    const href = link.getAttribute("href") || "";
    const base64 = href.split("base64,")[1];
    if (!base64) return;
    try {
      setReportContent(base64ToUtf8(base64));
    } catch (e) {
      console.log("Не удалось декодировать рецензию", e);
    }
  }
  return (
    <div onClick={handleClick}>
      <TableLoader {...loader} />
      <MarkdownReportModal
        content={reportContent}
        onClose={() => setReportContent(null)}
      />
    </div>
  );
}

export default WrittenWorks;
